import {MODEL_ACTIONS} from "~/actions/model_actions";
import {modify} from "mythil/object";
import {reduceAutocompleteOptions} from "~/rx/model/fieldOptions";
import identify from "~/identify";

export default function reduceFieldOptions({ state, fieldName, val, field, action }) {
    switch(action.type) {
        case MODEL_ACTIONS.CHANGE_SELECT_QUERY:
            if(action.query === val.query) { return val; }

            return {
                ...val,
                query: action.query,
                autocomplete: {
                    ...val.autocomplete,
                    status: identify.STATUS_STARTED,
                    started_at: Date.now()
                }
            };
    }

    return modify(val, 'autocomplete', (autocomplete) => reduceAutocompleteOptions(autocomplete, fieldName, action));
}